import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiGet } from "../../../api/apiGet";
import { defaultCart, defaultCartItem } from "../../../api/models/Cart";
import { apiPost } from "../../../api/apiPost";
import { apiDelete } from "../../../api/apiDelete";

// IF this does not return a cart, it means the user has never created one
export const getCart = createAsyncThunk(
  "cartSlice/getCart",
  async (_, thunkAPI) => {
    try {
      const response = await apiGet.getCart();
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue({
        code: err?.response?.data?.code,
      });
    }
  }
);

export const saveCartItem = createAsyncThunk(
  "cartSlice/saveCartItem",
  async ({ cartItem }, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const {
        cart: {
          cart: { cart_key },
        },
      } = state;

      const response = await apiPost.saveCartItem({
        cart_key,
        cart_item: { ...cartItem },
      });
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue({
        code: err?.response?.data?.code,
      });
    }
  }
);

export const deleteCartItem = createAsyncThunk(
  "cartSlice/deleteCartItem",
  async ({ key }, thunkAPI) => {
    try {
      const response = await apiDelete.deleteCartItem(key);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue({
        code: err?.response?.data?.code,
      });
    }
  }
);

export const cartSlice = createSlice({
  name: "cartSlice",
  initialState: {
    cartItems: [],
    cart: { ...defaultCart },
    dataLoad: true,
    cartNotice: null,
  },
  reducers: {
    addCartItem: (state, action) => {
      state.cartItems.push({
        ...defaultCartItem,
        ...action.payload,
      });
    },
    updateCartItem: (state, action) => {
      state.cartItems = state.cartItems.map((item) => {
        if (item.product_code === action.payload.product_code) {
          return { ...action.payload };
        }
        return item;
      });
    },
    removeCartItem: (state, action) => {
      state.cartItems = state.cartItems.filter(
        (item) => item.product_code !== action.payload.product_code
      );
    },
    setDataLoad: (state, action) => {
      state.dataLoad = action.payload;
    },
    clearCartNotice: (state) => {
      state.cartNotice = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveCartItem.fulfilled, (state, action) => {
        const { cart_items, cart_notice, ...cart } = action.payload;
        const sent = action.meta.arg.cartItem;
        const local = state.cartItems.find(
          (item) => item.product_code === sent.product_code,
        );
        // If the quantity was changed again while this save was out, keep the
        // newer local quantity -- App.js sends it once this save returns.
        state.cartItems = cart_items.map((item) =>
          local &&
          item.product_code === sent.product_code &&
          local.quantity !== sent.quantity
            ? { ...item, quantity: local.quantity }
            : item,
        );
        state.cart = cart;
        // Set by the backend when the product was already in the cart (e.g.
        // added from another tab) and the quantity was added to that line.
        if (cart_notice) state.cartNotice = cart_notice;
      })
      .addCase(getCart.fulfilled, (state, action) => {
        const { cart_items, ...cart } = action.payload;
        state.cartItems = cart_items;
        state.cart = cart;
      })
      .addCase(deleteCartItem.fulfilled, (state, action) => {
        const { cart_items, ...cart } = action.payload;
        state.cartItems = cart_items;
        state.cart = cart;
      });
  },
});

export const {
  addCartItem,
  updateCartItem,
  removeCartItem,
  setDataLoad,
  clearCartNotice,
} = cartSlice.actions;

export default cartSlice.reducer;
